module.exports = __webpack_public_path__ + "img/skin-redness-result-fr.226ede69.jpg";